export default class AnalysisExpense {
  constructor(field, amount) {
    this.field = field;
    this.amount = amount;
  }
}
